module.exports = __webpack_public_path__ + "img/telegram.ac7a4892.svg";